//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//

/**
 * The geo location configuration
 */
export interface GeoLocation {
    /**
     * The latitude
     */
    latitude: number;

    /**
     * The longitude
     */
    longitude: number;
}
